<template>
	<div class="serviceformContainer">
      <v-flex xs3>
        <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
      </v-flex>
		<v-data-table loading="true" :headers="headers" :items="processList" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr class="sortableRow" id="rows">
					<td width="30%">{{ props.item.name }}</td>
					<td width="18%" >{{ props.item.departmentName }}</td>
					<td width="14%" >{{ fncGetLocalizedDateFromUTC (props.item.created_on) }}</td>
					<td width="10%" >{{ props.item.id }}</td>
					<td width="7%" ><a v-if="fncCanDo()" @click.prevent="fncCreateLink(props.item)"><i class="material-icons">link</i></a></td>
					<td width="7%" ><a v-if="fncCanDo()" @click.prevent="fncShowEdit(props.item)"><i class="material-icons">edit</i></a></td>
					<td width="7%" ><a v-if="fncCanDo()" @click.prevent="fncProcessDelete(props.item)"><i class="material-icons">delete</i></a></td>
					<td width="7%" ><a v-if="fncCanDo()" @click.prevent="fncProcessDuplicate(props.item)"><i class="material-icons"><span class="material-icons-outlined">table_view</span></i></a></td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';

  export default {
	name: 'RoleList',
	intRoleEdit: 0,
    data () {
		return {
			search: '',
            headers: [
              { text: 'Name', value: 'name', width: '30%' },
              { text: 'Department', value: 'description', width: '18%' },
              { text: 'Created On', value: 'created_on', width: '14%' },
              { text: 'Process ID', value: 'created_on', width: '10%' },
              { text: 'Create Link', value: 'edit', width: '7%' },
              { text: 'Edit', value: 'edit', width: '7%' },
              { text: 'Delete', value: 'delete', width: '7%' },
              { text: 'Duplicate', value: 'duplicate', width: '7%' }
            ]
		}
	},
	methods: {
    fncCreateLink( item ) {
      var modalDetails = { title: 'Generate Service Form Link', component: 'modal-generate-link', mstate: true, params: item };
      this.$store.commit({
        type: 'setModal',
        details: modalDetails
      });
    },
	  fncCanDo() {
      if( this.objAuthorize.privileges.indexOf('AUDIT_SERVICE_FORMS') != -1 ) {
        return true;
      }
	    return false;
    },
    fncProcessDuplicate( item ) {
      var doDuplicate = confirm("Are you sure you want to duplicate " + item.name);
      if (doDuplicate == true) {
        this.$store.dispatch({
          type: 'fncProcessDuplicate',
          item: item
        });
      }
    },
    fncGetLocalizedDateFromUTC ( theDate ) {

      var options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        hour12: false
      };

      var newDate = new Date( Date.parse(theDate + ' UTC') );
      var dateString = newDate.toLocaleString("en", options);
      var objDate = dateString.split(',');

      var newDate = objDate[0].split('/');

      var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

      return strDate;

    },
    fncShowEdit(process) {
		  var modalDetails = { title: 'Edit Departmental Service Forms - ' + process.name, component: 'modal-process-edit', mstate: true, params: process };
		  this.$store.commit({
			  type: 'setModal',
			  details: modalDetails
		  });
		},
    fncProcessDelete(process) {
      var confirmDelete = confirm('Are you sure you would like to remove the process?');
      if (confirmDelete === true) {
        this.$store.dispatch({
          type: 'fncProcessDelete',
          processId: process.id
        });
      }
		},
	},
	computed: {
		...mapGetters([
			'userRoles',
			'objProcessEdit',
			'objAuthorize',
      'processList'
		])
	},
    beforeMount() {
      this.$store.dispatch('fncPopulateProcessList', this.objAuthorize.manufacturer);
	},
	  mounted() {
	  },
	  watch: {
		  branchList() {
		  }
	  }
}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
